<template>
  <div id="privacy-policy-content" ref="contentId" v-html="$t('owork_base.owork_user_policy.content_pc')"></div>
</template>

<script lang="ts" setup>
  import MarkdownIt from 'markdown-it'
  import { onMounted, nextTick, ref } from 'vue'
  import { privacyNative } from '@assets/privacy_native'
  import markdownTable from 'markdown-it-multimd-table'

  const contentId = ref<HTMLDivElement>()

  onMounted(() => {
    // 因为i18n的json对象存储markdown语法的冲突问题，使用renderWord将原始文件转译为html结构后再存储到json文件中，最终使用渲染富文本形式渲染json文件中的i18n语句
    // renderWord(privacyNative)
  })

  const renderWord = async (markdownText: string) => {
    const md = new MarkdownIt({ html: true }).use(markdownTable)

    const htmlText = md.render(markdownText)
    const content = contentId.value

    if (!content) return

    content.innerHTML = htmlText

    await nextTick()
    setLinkClick(content)
  }

  function setLinkClick(content: Element) {
    const aTags = content.getElementsByTagName('a')

    for (let i = 0; i < aTags.length; i++) {
      aTags[i].setAttribute('target', '_blank')
    }
  }
</script>
<style lang="stylus" scoped>
  #privacy-policy-content
    :deep(ol)
    :deep(ul)
    :deep(dl)
      margin-top 0
      margin-bottom 1em
      margin-left 20px
    :deep(table)
      border-collapse collapse
      border-spacing 0
      border 1px solid #cbcbcb
    :deep(th)
    :deep(td)
      border 1px solid #ccc
      text-align center
      padding 5px
    :deep(th)
      text-align center !important
      padding  10px 5px
</style>
